export const ndcMembership = [
	{
		id: 1,
		label: "Yes",
		value: "YES",
	},
	{
		id: 2,
		label: "No",
		value: "NO",
	},
];
export const genderData = [
	{
		id: 1,
		label: "Male",
		value: "MALE",
	},
	{
		id: 2,
		label: "Female",
		value: "FEMALE",
	},
];
export const maritalStatus = [
	{
		id: 1,
		label: "Single",
		value: "SINGLE",
	},
	{
		id: 2,
		label: "Married",
		value: "MARRIED",
	},
	{
		id: 3,
		label: "Divorced",
		value: "DIVORCED",
	},
	{
		id: 4,
		label: "Separated",
		value: "SEPERATED",
	},
	{
		id: 5,
		label: "Widowed",
		value: "WIDOWED",
	},
	{
		id: 6,
		label: "Prefer Not To Say",
		value: "PREFER NOT TO SAY",
	},
];

export const qualificationType = [
	{
		id: 1,
		label: "1ST Degree",
		value: "1ST DEGREE",
	},
	{
		id: 2,
		label: "2ND Degree",
		value: "2ND DEGREE",
	},
	{
		id: 3,
		label: "3RD Degree",
		value: "3RD DEGREE",
	},
	{
		id: 4,
		label: "Others",
		value: "OTHERS",
	},
];

export const employmentType = [
	{
		id: 1,
		label: "Formal",
		value: "FORMAL",
	},
	{
		id: 2,
		label: "Informal",
		value: "INFORMAL",
	},
	
];



export const regularData = {
	ndcMembership,
	genderData,
	maritalStatus,
	qualificationType,
	employmentType,
};
